import React, { useEffect, useState } from "react";
import fecha from 'fecha';

import { getClassType } from "../../../constants/Classes";
import { getQuotaType } from "../../../constants/Quotas";
import { config} from "../utils";
import { RAILS_CURR_AVL } from "../../../constants/TrainConstants";

const BookingInfo = ({
  status,
  response,
}) => {

  const [currAvl, setCurrAvl] = useState('');
  
  useEffect(() => {
    const currAvl = localStorage.getItem(RAILS_CURR_AVL);
    setCurrAvl(currAvl);
  }, [])

  if (status === config.STATUS.IP || status === config.STATUS.S) {
    return (
      <div className="bookingDetails__info">
        <div className="makeFlex hrtlCenter spaceBetween appendBottom20">
          <div className="railLoader" />
        </div>
      </div>
    )
  }

  if (status === config.STATUS.F) {
    return (
      <div className="bookingDetails__info">
        <div className="makeFlex hrtlCenter spaceBetween appendBottom20">
          { response.error }
        </div>
      </div>
    )
  }

  const {
    trainName,
    trainNumber,
    journeyClass,
    journeyQuota,
    fromStn,
    destStn,
    boardingDate,
    destArrvDate,
    departureTime,
    arrivalTime,
    updated,
  } = response;

  const getStationName = (stn) => {
    return `${stn.name} (${stn.code})`;
  }

  const getPrintableDate = (date) => {
    return fecha.format(new Date(date), 'DD MMM');
  }

  const getJsDate = (d, t) => {
    const hm = t.split(":").map(Number);
    const date = new Date(d);
    date.setHours(hm[0]);
    date.setMinutes(hm[1]);
    return date;
  }

  const minutesToHM = (m) => {
    const hours = Math.floor(m / 60);
    const minutes = m % 60;
    return `${hours}h ${minutes}m`;
  }

  const lastUpdatedAt = (date) => {
    return fecha.format(new Date(date), 'DD/MM/YYYY HH:MM');
  }

  const getJourneyTime = () => {
    const journeyTime = Math.abs(
      getJsDate(destArrvDate, arrivalTime) -
      getJsDate(boardingDate, departureTime)
    )
    return minutesToHM(
      journeyTime/(1000 * 60)
      
    );
  }

  return (
    <div className="bookingDetails__info">
      <div className="makeFlex hrtlCenter spaceBetween appendBottom20">
        <div>
          <p className="appendBottom20 font16 blackText latoBlack lineHeight20">
            { trainName }
          </p>
          <p className="appendBottom5 blackText">{getClassType(journeyClass).value}</p>
          <p>{getQuotaType(journeyQuota).value}</p>
        </div>
        <div className="textRight">
          <p className="appendBottom20 font16 lineHeight20">{`#${trainNumber}`}</p>
          <p className="appendBottom5 blackText">{currAvl}</p>
          <p>{lastUpdatedAt(updated)}</p>
        </div>
      </div>
      <div className="makeFlex baseline spaceBetween">
        <div>
          <p className="appendBottom5 ">
            <span className="latoBlack blackText font14">{departureTime}</span>, {getPrintableDate(boardingDate)}
          </p>
          <p>{getStationName(fromStn)}</p>
        </div>
        <p className="bookingDetails__time">{getJourneyTime()}</p>
        <div className="textRight">
          <p className="appendBottom5">
            <span className="latoBlack blackText font14">{arrivalTime}</span>, {getPrintableDate(destArrvDate)}
          </p>
          <p>{getStationName(destStn)}</p>
        </div>
      </div>
    </div>
  );
};

export default BookingInfo;
